export const OPTION_TYPES = {
  CHECKMARK: 'checkmark',
  CLOSE: 'close'
};
